/**
 * Helpers for building deep links into Azure DevOps / the Codie
 * extension. Centralised so the base URL and the Codie hub
 * contribution id are defined in exactly one place.
 */

/** Azure DevOps base URL, e.g. ``https://dev.azure.com``. */
const ADO_BASE_URL = 'https://dev.azure.com';

/**
 * Contribution id of the Codie hub plus the anchor that selects the
 * "Archie Imports" tab once the hub has loaded.
 */
const CODIE_ARCHIE_IMPORTS_HUB = '_apps/hub/Codie.Codier.codie-hub#archie-imports';

/**
 * Contribution id of the Codie hub plus the anchor that selects the
 * "Backlog monitoring" tab once the hub has loaded.
 */
const CODIE_BACKLOG_MONITORING_HUB =
  '_apps/hub/Codie.Codier.codie-hub#backlog-monitoring';

/**
 * Build a deep link to the Codie "Archie Imports" tab for the given
 * Azure DevOps org and project.
 *
 * @param adoOrg - The selected Azure DevOps organization name.
 * @param adoProject - The selected Azure DevOps project name.
 * @returns The fully encoded deep link URL.
 */
export function buildArchieImportsLink(
  adoOrg: string,
  adoProject: string,
): string {
  return (
    `${ADO_BASE_URL}/${encodeURIComponent(adoOrg)}` +
    `/${encodeURIComponent(adoProject)}/${CODIE_ARCHIE_IMPORTS_HUB}`
  );
}

/**
 * Build a deep link to the Codie "Backlog monitoring" tab for the
 * given Azure DevOps org and project.
 *
 * @param adoOrg - The selected Azure DevOps organization name.
 * @param adoProject - The selected Azure DevOps project name.
 * @returns The fully encoded deep link URL.
 */
export function buildBacklogMonitoringLink(
  adoOrg: string,
  adoProject: string,
): string {
  return (
    `${ADO_BASE_URL}/${encodeURIComponent(adoOrg)}` +
    `/${encodeURIComponent(adoProject)}/${CODIE_BACKLOG_MONITORING_HUB}`
  );
}
